<template>
    <div>
        <b-row
            v-bind:class="canEditField.hidden != true ? 'mb-2': ''"
            v-for="canEditField in canEditFields"
            :key="canEditField.key"
            :id="'grp_txt_' + canEditField.key"
        >
            <b-col class="col-3" v-if="canEditField.hidden != true">
                {{ canEditField.label }}
            </b-col>

            <b-col class="" v-if="canEditField.hidden != true">
                <b-form-group>
                    <div v-if="canEditField.type == 'readonly'" class="">
                        {{ 
                            (typeof canEditField.formattedText == 'function') ? 
                                canEditField.formattedText(payload[canEditField.key]) : 
                                payload[canEditField.key]
                        }}
                    </div>

                    <div v-if="canEditField.type == 'textonly'" class="">
                        {{canEditField.content}}
                    </div>

                    <b-form-textarea
                        v-if="canEditField.type == 'textarea'"
                        rows="3"
                        size="sm"
                        type="text"
                        placeholder
                        v-model="payload[canEditField.key]"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        v-on:input="onChangeData(payload)"
                    ></b-form-textarea>

                     <b-form-input
                        v-if="canEditField.type == 'text'"
                        type="text"
                        size="sm"
                        required
                        placeholder
                        v-model="payload[canEditField.key]"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        v-on:input="onChangeData(payload)"
                        @blur="canEditField.onblur?canEditField.onblur(payload[canEditField.key]):null"
                    ></b-form-input>

                    <b-form-input
                        v-if="canEditField.type == 'password'"
                        type="password"
                        size="sm"
                        required
                        placeholder
                        v-model="payload[canEditField.key]"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        v-on:input="onChangeData(payload)"
                    ></b-form-input>

                    <b-form-input
                        v-if="canEditField.type == 'date'"
                        type="date"
                        size="sm"
                        required
                        placeholder
                        v-model="payload[canEditField.key]"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        @change="onChangeData(payload)"
                    ></b-form-input>

                    <b-form-select
                        v-if="canEditField.type == 'select'"
                        size="sm"
                        :options="canEditField.options"
                        v-model="payload[canEditField.key]"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        @input="onChangeData(payload)"
                    />

                    <b-form-checkbox
                        v-if="canEditField.type == 'checkbox'"
                        size="sm"
                        value="1"
                        unchecked-value="0"
                        plain
                        v-model="payload[canEditField.key]"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        @change="onChangeData(payload)"
                    ></b-form-checkbox>

                    <multiselect
                        v-if="canEditField.type == 'search_select'"
                        v-model="payload[canEditField.key]"
                        id="ajax"
                        label="name"
                        track-by="value"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="search_select_options[canEditField.key]"
                        :multiple="false"
                        :searchable="true"

                        :loading="isLoading[canEditField.key]"
                        :internal-search="false"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="query => asyncFind(query, canEditField)"
                        @open="query => asyncFind('', canEditField)"
                        @select="onChangeData(payload)"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        @change="onChangeData(payload)"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                            option.name
                        }}</template>
                        <span slot="noResult">No record found.</span>
                    </multiselect>

                    <multiselect
                        v-if="canEditField.type == 'search_select_tag'"
                        v-model="payload[canEditField.key]"
                        id="ajax"
                        label="name"
                        track-by="value"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="search_select_options[canEditField.key]"
                        :multiple="false"
                        :searchable="true"
                        :taggable="true"
                        @tag="canEditField.addTag"
                        :loading="isLoading[canEditField.key]"
                        :internal-search="false"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="query => asyncFind(query, canEditField)"
                        @open="query => asyncFind('', canEditField)"
                        @select="onChangeData(payload)"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        @change="onChangeData(payload)"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                            option.name
                        }}</template>
                        <span slot="noResult">No record found.</span>
                    </multiselect>

                    <multiselect
                        v-if="canEditField.type == 'multi_select'"
                        v-model="payload[canEditField.key]"
                        id="ajax"
                        label="name"
                        track-by="value"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="search_select_options[canEditField.key]"
                        :multiple="true"
                        :searchable="true"
                        :loading="isLoading[canEditField.key]"
                        :internal-search="false"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="query => asyncFind(query, canEditField)"
                        @open="query => asyncFind('', canEditField)"
                        @select="onChangeData(payload)"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        @change="onChangeData(payload)"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                            option.name
                        }}</template>
                        <span slot="noResult">No record found.</span>
                    </multiselect>

                    <multiselect
                        v-if="canEditField.type == 'multi_select_local'"
                        v-model="payload[canEditField.key]"
                        id="ajax"
                        label="name"
                        track-by="value"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="canEditField.options"
                        :multiple="true"
                        :searchable="true"
                        :internal-search="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @select="onChangeData(payload)"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        @change="onChangeData(payload)"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                            option.name
                        }}</template>
                        <span slot="noResult">No record found.</span>
                    </multiselect>

                    <multiselect
                        v-if="canEditField.type == 'single_select'"
                        v-model="payload[canEditField.key]"
                        id="ajax"
                        label="name"
                        track-by="value"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="search_select_options[canEditField.key]"
                        :multiple="false"
                        :searchable="false"
                        :loading="isLoading[canEditField.key]"
                        :internal-search="false"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="query => asyncFind(query, canEditField)"
                        @open="asyncFind('', canEditField)"
                        @select="onChangeData(payload)"
                        :disabled="canEditField.disable"
                        :state="validateState(canEditField.key)"
                        @change="onChangeData(payload)"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                            option.name
                        }}</template>
                        <span slot="noResult">No record found.</span>
                    </multiselect>

                    <b-button
                        v-if="canEditField.button"
                        class="btn-action mt-2"
                        size="sm"
                        variant="info"
                        @click="canEditField.button.onClick"
                    >
                        {{canEditField.button.text}}
                    </b-button>
                    <b-form-invalid-feedback
                        v-if="getErrorMessages != null"
                        class="txt_normal_text_transform"
                        v-for="error in getErrorMessages(canEditField.key)"
                        :key="error"
                        >{{ error }}</b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: "FormInput",
    components: {
        Multiselect
    },
    props: {
        data: Object,
        canEditFields: Array,
        validateState: Function,
        getErrorMessages: Function,
        onChangeData: Function,
    },
    data() {
        let search_select_options = {};
        this.canEditFields.forEach(f => {
            if (f.type === "single_select" || f.type === "multi_select" || f.type === "search_select" || f.type === "search_select_tag") {
                search_select_options[f.key] = [];
            }
        })
        
        return {
            payload: { ...this.data },
            isLoading: {},
            search_select_options,
        };
    },
    watch: {
        data: function(value) {
            this.payload = value;
        },
    },
    computed: {},
    methods: {
        limitText(count) {
            return `and ${count} other records`;
        },
        async asyncFind(query, data) {
            if (data.fetchOptions) {
                this.isLoading[data.key] = true;
                let options = await data.fetchOptions(query);
                this.search_select_options[data.key] = options;
                this.isLoading[data.key] = false;
            }
        },
    }
};
</script>

<style scoped>
.form-group {
    margin-bottom: 0;
    margin-top: 0;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/common/FormInput.vue